import React from 'react';
import { BookOpenIcon, PlayCircleIcon, BookIcon, CheckSquareIcon, ArrowRightIcon } from 'lucide-react';
export const AgelessWissen: React.FC = () => {
  return <div className="p-4 md:p-6 md:ml-64 pb-16 md:pb-6" data-id="element-65">
      <div className="mb-6" data-id="element-66">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-67">Ageless Wissen</h1>
        <p className="text-gray-600" data-id="element-68">Lernen in kleinen Dosen</p>
      </div>
      {/* Today's Lesson */}
      <section className="mb-8" data-id="element-69">
        <div className="flex justify-between items-center mb-4" data-id="element-70">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-71">
            Heutige Lektion
          </h2>
          <span className="bg-green-100 text-green-600 text-xs px-2 py-1 rounded-full" data-id="element-72">
            Neu
          </span>
        </div>
        <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-73">
          <div className="h-40 bg-purple-200 relative" data-id="element-74">
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-75">
              <PlayCircleIcon size={48} className="text-purple-600" data-id="element-76" />
            </div>
          </div>
          <div className="p-4" data-id="element-77">
            <h3 className="font-bold text-gray-800 mb-1" data-id="element-78">
              Was ist NAD+ und warum ist es wichtig?
            </h3>
            <p className="text-sm text-gray-500 mb-3" data-id="element-79">3 Minuten Lesezeit</p>
            <p className="text-sm text-gray-600 mb-4" data-id="element-80">
              NAD+ ist ein essentielles Coenzym, das in jeder Zelle deines
              Körpers vorkommt und für die Energieproduktion und DNA-Reparatur
              entscheidend ist.
            </p>
            <button className="bg-purple-600 text-white px-4 py-2 rounded-lg text-sm font-medium w-full" data-id="element-81">
              Jetzt lernen
            </button>
          </div>
        </div>
      </section>
      {/* Learning Paths */}
      <section className="mb-8" data-id="element-82">
        <div className="flex justify-between items-center mb-4" data-id="element-83">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-84">
            Deine Lernpfade
          </h2>
          <button className="text-purple-600 flex items-center text-sm font-medium" data-id="element-85">
            Alle anzeigen <ArrowRightIcon size={16} className="ml-1" data-id="element-86" />
          </button>
        </div>
        <div className="space-y-4" data-id="element-87">
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-88">
            <div className="flex justify-between items-center mb-3" data-id="element-89">
              <div className="flex items-center" data-id="element-90">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-91">
                  <BookIcon size={20} className="text-blue-600" data-id="element-92" />
                </div>
                <p className="font-medium text-gray-800" data-id="element-93">
                  Grundlagen der Longevity
                </p>
              </div>
              <span className="text-sm text-purple-600" data-id="element-94">
                4/10 abgeschlossen
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 mb-3" data-id="element-95">
              <div className="bg-purple-600 h-2 rounded-full" style={{
              width: '40%'
            }} data-id="element-96"></div>
            </div>
            <div className="flex justify-between text-xs text-gray-500" data-id="element-97">
              <span data-id="element-98">Nächste Lektion: "Die Hallmarks of Aging"</span>
              <span data-id="element-99">5 Min.</span>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-4" data-id="element-100">
            <div className="flex justify-between items-center mb-3" data-id="element-101">
              <div className="flex items-center" data-id="element-102">
                <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-3" data-id="element-103">
                  <BookIcon size={20} className="text-green-600" data-id="element-104" />
                </div>
                <p className="font-medium text-gray-800" data-id="element-105">Ernährung & Fasten</p>
              </div>
              <span className="text-sm text-purple-600" data-id="element-106">2/8 abgeschlossen</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 mb-3" data-id="element-107">
              <div className="bg-purple-600 h-2 rounded-full" style={{
              width: '25%'
            }} data-id="element-108"></div>
            </div>
            <div className="flex justify-between text-xs text-gray-500" data-id="element-109">
              <span data-id="element-110">Nächste Lektion: "Autophagie verstehen"</span>
              <span data-id="element-111">4 Min.</span>
            </div>
          </div>
        </div>
      </section>
      {/* Quick Lessons */}
      <section className="mb-8" data-id="element-112">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-113">
          Schnelle Lektionen für dich
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-114">
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-115">
            <div className="p-4" data-id="element-116">
              <div className="flex items-center mb-3" data-id="element-117">
                <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-118">
                  <PlayCircleIcon size={20} className="text-orange-600" data-id="element-119" />
                </div>
                <div data-id="element-120">
                  <p className="font-medium text-gray-800" data-id="element-121">
                    Wie wirkt Kälteexposition?
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-122">2 Min. Audio</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-123">
            <div className="p-4" data-id="element-124">
              <div className="flex items-center mb-3" data-id="element-125">
                <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-3" data-id="element-126">
                  <CheckSquareIcon size={20} className="text-purple-600" data-id="element-127" />
                </div>
                <div data-id="element-128">
                  <p className="font-medium text-gray-800" data-id="element-129">
                    Schlafoptimierung Quiz
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-130">5 Fragen</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-131">
            <div className="p-4" data-id="element-132">
              <div className="flex items-center mb-3" data-id="element-133">
                <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center mr-3" data-id="element-134">
                  <PlayCircleIcon size={20} className="text-red-600" data-id="element-135" />
                </div>
                <div data-id="element-136">
                  <p className="font-medium text-gray-800" data-id="element-137">Stress & Cortisol</p>
                  <p className="text-xs text-gray-500" data-id="element-138">3 Min. Video</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-139">
            <div className="p-4" data-id="element-140">
              <div className="flex items-center mb-3" data-id="element-141">
                <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center mr-3" data-id="element-142">
                  <BookOpenIcon size={20} className="text-blue-600" data-id="element-143" />
                </div>
                <div data-id="element-144">
                  <p className="font-medium text-gray-800" data-id="element-145">
                    Hormone & Alterung
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-146">4 Min. Lesezeit</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Progress */}
      <section data-id="element-147">
        <div className="bg-purple-50 rounded-xl p-4" data-id="element-148">
          <div className="flex items-center justify-between mb-3" data-id="element-149">
            <h3 className="font-semibold text-gray-800" data-id="element-150">
              Dein Lernfortschritt
            </h3>
            <span className="text-sm text-purple-600 font-medium" data-id="element-151">Level 3</span>
          </div>
          <div className="w-full bg-white rounded-full h-3 mb-3" data-id="element-152">
            <div className="bg-purple-600 h-3 rounded-full" style={{
            width: '65%'
          }} data-id="element-153"></div>
          </div>
          <div className="flex justify-between text-sm" data-id="element-154">
            <span className="text-gray-600" data-id="element-155">12 Lektionen abgeschlossen</span>
            <span className="text-purple-600" data-id="element-156">35% bis Level 4</span>
          </div>
        </div>
      </section>
    </div>;
};